import { Ellipse } from './Ellipse'
import { Position } from './Position'
import { SocialMedia } from './SocialMedia'
import { Text } from './Text'

export const Button = { Ellipse, Text, Position, SocialMedia }
